import React from 'react'
import ExistingSubscriptionDetails from '../../components/User/ExistingSubscription';

const ExistingSubscription = () => {
  return (
    <ExistingSubscriptionDetails />
  )
}

export default ExistingSubscription;